import { Button, Radio } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

import { DIMENSION_LABELS, normalizePivot } from "./reportingUtils";

const PLACES = [
  { value: "rows", label: "Rows" },
  { value: "columns", label: "Columns" },
];

const rowStyle = { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 };

/**
 * Places business case/scenario, account and period in rows or columns
 * (settings.pivot). The order of the list is the nesting: the first dimension
 * in rows (or columns) is the outermost.
 */
export default function PivotEditor({ pivot, onChange }) {
  const { rows, columns } = normalizePivot(pivot);
  const items = [...rows.map((dim) => ({ dim, place: "rows" })), ...columns.map((dim) => ({ dim, place: "columns" }))];

  const emit = (next) =>
    onChange({
      rows: next.filter((x) => x.place === "rows").map((x) => x.dim),
      columns: next.filter((x) => x.place === "columns").map((x) => x.dim),
    });

  // Moves within its own group (rows or columns) only; that's what the order means.
  const move = (index, direction) => {
    const next = [...items];
    [next[index], next[index + direction]] = [next[index + direction], next[index]];
    emit(next);
  };
  // Moving to the other group puts the dimension innermost there.
  const place = (index, value) => {
    const moved = { ...items[index], place: value };
    const others = items.filter((_, i) => i !== index);
    emit(value === "rows" ? [...others.filter((x) => x.place === "rows"), moved, ...others.filter((x) => x.place !== "rows")] : [...others, moved]);
  };

  return (
    <div>
      {items.map((item, index) => {
        const alone = item.place === "rows" ? rows.length === 1 : columns.length === 1;
        const sameGroup = (i) => items[i]?.place === item.place;
        return (
          <div key={item.dim} style={rowStyle}>
            <span style={{ width: 170 }}>{DIMENSION_LABELS[item.dim]}</span>
            <Radio.Group
              size="small"
              optionType="button"
              value={item.place}
              options={PLACES.map((o) => ({ ...o, disabled: alone && o.value !== item.place }))}
              onChange={(e) => place(index, e.target.value)}
            />
            <Button type="text" size="small" icon={<ArrowUpOutlined />} disabled={!sameGroup(index - 1)} onClick={() => move(index, -1)} />
            <Button type="text" size="small" icon={<ArrowDownOutlined />} disabled={!sameGroup(index + 1)} onClick={() => move(index, 1)} />
          </div>
        );
      })}
      <div style={{ marginTop: 4, fontSize: 12, opacity: 0.65 }}>
        Rows: {rows.map((d) => DIMENSION_LABELS[d]).join(" › ")} · Columns: {columns.map((d) => DIMENSION_LABELS[d]).join(" › ")}.
        The first one is the outermost; use the arrows to change the order.
      </div>
    </div>
  );
}
